const services = [
    {
      id: 1,
      serviceKey: "aluminum-installation",
      title: "Aluminum Doors & Windows Installation",
      description: "Professional installation of aluminum doors and windows with precision fitting and weatherproofing.",
      features: ["Precision Fitting", "Weather Sealing", "Quality Hardware"],
      // icon: <Wrench className="w-8 h-8" />,
      image: "/images/aluminium_doors.jpeg"
    },
    {
      id: 2,
      serviceKey: "hardware-installation",
      title: "Door & Window Accessories Installation",
      description: "Complete installation of locks, handles, hinges, and all door/window accessories.",
      features: ["Professional Hardware", "Security Systems", "Smooth Operation"],
      // icon: <Shield className="w-8 h-8" />,
      image: "/images/window_accessories.jpeg"
    },
    {
      id: 3,
      serviceKey: "shower-installation",
      title: "Shower Cabinet Installation",
      description: "Expert installation of shower cabinets with proper waterproofing and drainage systems.",
      features: ["Waterproof Sealing", "Proper Drainage", "Modern Design"],
      // icon: <CheckCircle className="w-8 h-8" />,
      image: "/images/shower_cabinet2.jpg"
    },
    {
      id: 4,
      serviceKey: "concrete-installation",
      title: "Concrete Block Installation",
      description: "Professional laying of concrete hollow blocks and paving blocks for construction projects.",
      features: ["Structural Integrity", "Level Installation", "Durable Foundation"],
      // icon: <Clock className="w-8 h-8" />,
      image: "/images/concrete_block.jpeg"
    },
    {
      id: 5,
      serviceKey: "brick-installation",
      title: "Brick Wall & Retaining Wall Installation",
      description: "Expert installation of brick slips, wall tiles, and retaining wall concrete blocks.",
      features: ["Aesthetic Appeal", "Structural Support", "Long-lasting"],
      // icon: <Wrench className="w-8 h-8" />,
      image: "/images/brick_walls.jpeg"
    },
    {
      id: 6,
      serviceKey: "general-installation",
      title: "General Construction Services",
      description: "Complete construction and installation services for all your building needs.",
      features: ["Full Service", "Quality Assurance", "Timely Completion"],
      // icon: <Shield className="w-8 h-8" />,
      image: "/images/general_contractor.jpeg"
    }
  ];



export default services